import Vue from 'vue';
import VueApollo from 'vue-apollo';
import createDefaultClient from '~/lib/graphql';
import ComplianceInfo from './components/compliance_info.vue';

const apolloProvider = new VueApollo({
  defaultClient: createDefaultClient(),
});

export function initComplianceInfo() {
  const el = document.getElementById('js-compliance-info');

  if (!el) {
    return null;
  }

  const { projectPath, complianceCenterPath, canViewDashboard } = el.dataset;

  return new Vue({
    el,
    name: 'ComplianceInfoRoot',
    apolloProvider,
    render(h) {
      return h(ComplianceInfo, {
        props: {
          projectPath,
          complianceCenterPath,
          canViewDashboard,
        },
      });
    },
  });
}
